import { Flex, Typography, IconLink, RemoteImage } from '@banhala/ui-kit';
import React from 'react';
import { Pressable } from 'react-native';
import { type SuggestItem } from '../../../../constants';
import { SUGGESTER_LINK_TEXT, SuggestType, toSuggestType } from './SuggestType';
import { renderHTMLToText } from 'shared/src/utils';

type Props = {
  item: SuggestItem;
  onPress: (item: SuggestItem) => void;
  showBottomLine?: boolean;
};

export const SuggestRow: React.FC<Props> = ({
  item,
  onPress,
  showBottomLine,
}) => {
  const isOfficialMarket = item.type === SuggestType.OFFICIAL_MARKET;
  const suggestType = toSuggestType(item.type);
  const linkText = suggestType ? SUGGESTER_LINK_TEXT[suggestType] : null;

  return (
    <Pressable onPress={() => onPress(item)}>
      {({ pressed }) => (
        <Flex backgroundColor={pressed ? 'bg_pressed_primary' : 'white'}>
          <Flex.Row
            padding={{ horizontal: 16 }}
            height={52}
            alignItems="center"
            gap={12}
          >
            {item.thumbnail_url && (
              <Flex
                width={32}
                height={32}
                borderRadius={16}
                borderWidth={1}
                borderColor="border_transparent"
                overflow="hidden"
                justifyContent="center"
                alignItems="center"
              >
                <RemoteImage
                  uri={item.thumbnail_url}
                  width={32}
                  height={32}
                  resizeMode="cover"
                />
              </Flex>
            )}

            <Typography numberOfLines={1} type="body1" color="content_primary">
              {renderHTMLToText(item.highlight)}
            </Typography>

            {isOfficialMarket && (
              <Flex
                padding={{ horizontal: 6, vertical: 2 }}
                borderRadius={4}
                backgroundColor="bg_secondary"
              >
                <Typography type="body6" color="content_secondary">
                  브랜드 공식 마켓
                </Typography>
              </Flex>
            )}

            <Flex flex={1} />

            <Flex.Row alignItems={'center'} gap={4}>
              {item.type && (
                <Typography color="content_blue_primary">{linkText}</Typography>
              )}
              {suggestType !== 'QUERY' && suggestType !== 'DEEPLINK' && (
                <IconLink size={16} fill={'#2572F7'} />
              )}
            </Flex.Row>
          </Flex.Row>

          {showBottomLine && <Flex height={1} backgroundColor="gray20" />}
        </Flex>
      )}
    </Pressable>
  );
};
